import { useCallback } from 'react';
import { IllustrativeIcon, Txt } from '@vst/beam';
import { WhatToExpect } from '@vst/beam-icons/illustrative-icons';
import { useTranslation } from 'react-i18next';

import { CustomDecorativeModal } from '@app/components/Modal';
import { useScreenResolution } from '@app/hooks';

import { ErrorEnum } from '../utils/types';

type CheckoutTransactionErrorProps = {
  isModalOpen: boolean;
  handleClose: (isSuccess: boolean, error?: ErrorEnum) => void;
};

const CheckoutTransactionError = (props: CheckoutTransactionErrorProps): JSX.Element => {
  const { handleClose, isModalOpen } = props;
  const { t } = useTranslation('BuyMore');

  const { isSmall, isExtraSmall } = useScreenResolution();
  const isMobile = isSmall || isExtraSmall;

  const handleModalClose = useCallback(() => {
    handleClose(false, ErrorEnum.PURCHASE_TRANSACTION_ERROR);
  }, [handleClose]);

  return (
    <CustomDecorativeModal
      header={t('Global.error.title')}
      isOpen={isModalOpen}
      actions={{
        primary: {
          label: t('Checkout.error.buttons.close'),
          onClick: handleModalClose,
        },
      }}
      onClose={handleModalClose}
      icon={<IllustrativeIcon icon={WhatToExpect} color="teal_600" />}
    >
      <Txt color="subtle" variant={isMobile ? 'bodySmallRegular' : 'bodyLargeRegular'}>
        {t('Checkout.error.description.unexpected')}
      </Txt>
    </CustomDecorativeModal>
  );
};

export default CheckoutTransactionError;
